type StatusType = 'success' | 'warning' | 'error' | 'info' | 'neutral';

interface StatusBadgeProps {
  status: StatusType;
  label: string;
}

const statusStyles: Record<StatusType, string> = {
  success: 'bg-emerald-50 text-emerald-700 ring-emerald-600/20',
  warning: 'bg-amber-50 text-amber-700 ring-amber-600/20',
  error: 'bg-red-50 text-red-700 ring-red-600/20',
  info: 'bg-sky-50 text-sky-700 ring-sky-600/20',
  neutral: 'bg-slate-100 text-slate-700 ring-slate-500/15',
};

export function StatusBadge({ status, label }: StatusBadgeProps) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset whitespace-nowrap ${statusStyles[status]}`}
    >
      {label}
    </span>
  );
}

// Helpers for common status mappings
export function getDeliveryStatusType(status: string): StatusType {
  switch (status) {
    case 'sent':
      return 'success';
    case 'queued':
      return 'info';
    case 'failed':
      return 'error';
    case 'skipped':
      return 'warning';
    default:
      return 'neutral';
  }
}

export function getPlatformStatusType(platform: string): StatusType {
  switch (platform) {
    case 'ios':
      return 'info';
    case 'android':
      return 'success';
    default:
      return 'neutral';
  }
}
